module.exports = __webpack_public_path__ + "assets/img/icon_teaching_work@2x.636abbda.png";